<template>
  <v-menu
      :close-on-content-click="autoclose"
      :disabled="disabled"
      :nudge-right="40"
      full-width
      lazy
      min-width="290px"
      offset-y
      ref="menu"
      transition="scale-transition"
      v-model="menu"
  >
    <template #activator="{ on }">
      <v-text-field
        :disabled="disabled"
        :label="label"
        :required="required"
        @focus="dateInputFocused = true"
        prepend-icon="event"
        @click:prepend="!disabled ? on.click : null"
        mask="####"
        v-bind="$attrs"
        :value="value"
        @blur="emitValue($event.target.value)"
      />
    </template>
    <v-date-picker
      reactive
      show-current
      ref="picker"
      @input="onDateSelected"
      :disabled="disabled"
      :min="minYear"
      :max="maxYear"
      no-title
    />
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'nx-year-picker',
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    minYear: {
      type: String,
      default: '1900',
    },
    maxYear: {
      type: String,
      default: '2030',
    },
    required: {
      type: Boolean,
    },
    autoclose: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      dateInputFocused: false,
    };
  },
  computed: {
    focused() {
      return this.dateInputFocused || this.menu;
    },
  },

  watch: {
    focused(focused) {
      const event = focused ? 'focus' : 'blur';
      this.$emit(event, focused);
    },
    menu(value) {
      if (!value) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.picker.activePicker = 'YEAR';
      });
    },
  },

  methods: {
    emitValue(value) {
      this.menu = false;
      this.dateInputFocused = false;
      if (value === null) {
        this.$emit('input', null);
        return;
      }
      if (value < this.minYear) {
        this.$emit('input', this.minYear);
        return;
      }
      this.$emit('input', Number(value));
    },
    onDateSelected(date) {
      const value = moment(date).format('YYYY');
      this.emitValue(value);
    },
  },
};
</script>
